import { Action, action, Thunk, thunk } from 'easy-peasy';
import { OrderedMap } from 'immutable';
import { PricingRuleVp, RuleStates } from '../api/types';
import { StoreModel } from './types';
import { pricingRulesVpApi } from '../api';

export const defaultPricingRuleVp: PricingRuleVp = {
  id: -1,
  categories: [{ name: '', id: '' }],
  suppliers: [{ name: '', id: '' }],
  state:RuleStates.DRAFT,
  name: '',
  parameterGroups: [{
    id: -1, name: 'Parameter group 1',
    intervals: [{ id: -1 }],
    parameters: [{ id: '', name: '' }],
  }],
  validFrom: '',
  validTo: '',
  active: true,
};

export interface PricingRulesVpStore {
  isLoading: boolean;
  list: OrderedMap<number, PricingRuleVp>;
  detail: PricingRuleVp;
  selectedDetailId: number;
  setSelectedDetailId: Action<PricingRulesVpStore, number>;
  setLoading: Action<PricingRulesVpStore, boolean>;
  setList: Action<PricingRulesVpStore, PricingRuleVp[]>;
  setDetail: Action<PricingRulesVpStore, PricingRuleVp>;
  fetchList: Thunk<PricingRulesVpStore, void, any, StoreModel>;
  fetchPricingRule: Thunk<PricingRulesVpStore,
    number,
    any,
    StoreModel,
    Promise<boolean>>;
  createPricingRule: Thunk<PricingRulesVpStore,
    PricingRuleVp,
    any,
    StoreModel,
    Promise<boolean>>;
  updatePricingRule: Thunk<PricingRulesVpStore,
    PricingRuleVp,
    any,
    StoreModel,
    Promise<boolean>>;
  deletePricingRule: Thunk<PricingRulesVpStore,
    number,
    any,
    StoreModel,
    Promise<boolean>>;
}

const pricingRulesVp: PricingRulesVpStore = {
  isLoading: false,
  list: OrderedMap(),
  detail: defaultPricingRuleVp,
  selectedDetailId: -1,
  setSelectedDetailId: action((state, payload) => {
    state.selectedDetailId = payload;
  }),
  setLoading: action((state, payload) => {
    state.isLoading = payload;
  }),
  setList: action((state, payload) => {
    state.list = OrderedMap(payload.map(v => [v.id, v]));
  }),
  setDetail: action((state, payload) => {
    state.detail = payload;
  }),
  fetchList: thunk(async actions => {
    try {
      actions.setLoading(true);
      const { data } = await pricingRulesVpApi.getPricingRulesList();
      actions.setList(data);
      actions.setLoading(false);
    } catch (error) {
      actions.setLoading(false);
    }
  }),
  fetchPricingRule: thunk(async (actions, id) => {
    try {
      const { data } = await pricingRulesVpApi.getPricingRuleDetail(id);
      if (data && data.parameterGroups) {
        data.parameterGroups.sort((a, b) => {
          if (a.id < b.id) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
        });
      }
      actions.setDetail(data);
    } catch (error) {
      return false;
    }
    return true;
  }),
  createPricingRule: thunk(async (actions, value) => {
    try {
      await pricingRulesVpApi.createPricingRule(value);
      await actions.fetchList();
    } catch (error) {
      return false;
    }
    return true;
  }),
  updatePricingRule: thunk(async (actions, value) => {
    try {
      await pricingRulesVpApi.updatePricingRule(value);
      await actions.fetchList();
    } catch (error) {
      return false;
    }
    return true;
  }),
  deletePricingRule: thunk(async (actions, value) => {
    try {
      actions.setLoading(true);
      await pricingRulesVpApi.deletePricingRule(value);
      await actions.fetchList();
    } catch (error) {
      actions.setLoading(false);
      return false;
    }
    return true;
  }),
};

export default pricingRulesVp;
